import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailFrownLine({data, img}) {
    return (
        <MeasurementResult type="미간 주름" description='"미간 주름"은 이마에 형성되는 주름을 가리킵니다. 일반적으로 표정을 자주 쓰거나 피부 노화로 인해 발생하며, 노화와 함께 깊이와 심각성이 증가할 수 있습니다. 아래는 0단계부터 8단계까지 미간 주름의 변화를 설명한 것입니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }
                        {
                        img.image_mark_frown_wrinkle_front &&
                        <img src={img.image_mark_frown_wrinkle_front} />
                        }

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="미간 주름"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0",
                    },
                    {
                        value: "경도",
                        label: "1",
                    },
                    {
                        value: "경도",
                        label: "2",
                    },
                    {
                        value: "경도",
                        label: "3",
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중간 정도",
                        label: "5"
                    },
                    {
                        value: "중간 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                    {
                        value: "중증 정도",
                        label: "8"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult} 
                />
            </div>
        </MeasurementResult>
    )
}